export default __webpack_public_path__ + "static/media/hedonism.b994098b.webp";